import React, { useContext } from 'react';

export const useTypedContext = <T>(
  context: React.Context<T | undefined>
): T => {
  const baseContext = useContext(context);
  return baseContext as T;
};
